import styled from 'styled-components';

interface Props {
  headerWithReturnButton?: boolean;
}

export const HeaderContainer = styled.header`
  max-width: 1080px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  border-top: 24px;
  border-bottom: 0;
  padding: 24px 0px 8px;
  font-size: 14px;

  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;

  @media (max-width: 1024px) {
    padding: 24px 5px 8px;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const HeaderRight = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Logo = styled.div`
  display: flex;
  justify-content: center;
  > img {
    width: 233px;
    height: 32px;
    @media (max-width: 1024px) {
      width: 204px;
      height: 28px;
    }
  }
`;

export const ReturnButton = styled.button`
  display: flex;
  margin-right: auto;
  height: 32px;
  width: 92px;

  border: 0;
  background-color: transparent;

  align-items: center;
  padding: 0;

  color: ${props => props.theme.colors?.primary.main.color};
  font-size: 18px;
  > img {
    transform: rotate(180deg);
    margin: 0 10px 0 15px;
  }
  > span {
    @media (max-width: 1024px) {
      display: none;
    }
  }
  @media (max-width: 680px) {
    max-width: 40px;
    margin-right: -40px;
    margin-left: 19px;
  }
`;

export const UserMenu = styled.div<Props>`
  flex: 1 12px;
  display: flex;
  justify-content: right;
  color: ${props => props.theme.colors?.primary.main.color};
  margin-left: auto;

  position: relative;
  align-items: center;
  width: ${props => (props.headerWithReturnButton ? '' : '0px')};
  white-space: nowrap;
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const OpenUserMenu = styled.div`
  border-radius: 8px;
  background: #005cde;
  text-align: right;
  font-size: 12px;
  color: #444;
  margin: 15px 0 0;
  padding: 10px;
  position: absolute;
  right: 0;
  top: 20px;
  line-height: 22px;
  font-weight: 600;
  font-weight: 700;
  > span {
    font-size: 14px;
    color: #ffffff;
  }
  > a {
    margin: 0 0 0 5px;
    color: #ffffff;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  .top-bot {
    position: absolute;
    top: -14px;
    right: 3px;
    width: 0px;
    height: 0;
    border-width: 8px;
    border-style: solid;
    border-color: transparent transparent #005cde transparent;
  }
`;

export const Button = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.colors?.primary.main.color};
  display: flex;
  align-items: center;
  > img {
    margin: 0 5px 0 10px;
  }
  > span {
    font-size: 16px;
  }
`;
